/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Node } from '../../../core/models/Node';
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { Aai20Schema } from './Aai20Schema';
import { Document } from '../../../core/models/Document';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends Aai20Schema
 * @author laurent.broudoux@gmail.com
 */
export class Aai20SchemaDefinition extends Aai20Schema implements IDefinition {
    /*private*/ _name : string;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this._name===undefined) this._name = null;
            (() => {
                this._name = name;
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super();
            if(this._name===undefined) this._name = null;
            if(this._name===undefined) this._name = null;
            (() => {
                this._name = name;
            })();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitSchemaDefinition(this);
    }
}
Aai20SchemaDefinition["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20SchemaDefinition";
Aai20SchemaDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.common.IPropertyParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];




